import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface CU05504State {
    isChecking: boolean;
}

const initialState: CU05504State = {
    isChecking: false,
};

export const CU05504Slice = createSlice({
    name: 'CU05504Slice',
    initialState,
    reducers: {
        toggleChecking: (state) => {
            state.isChecking = !state.isChecking;
        },
        resetCU05504Slice: () => initialState,
    },
});

export const { toggleChecking } = CU05504Slice.actions;

export default CU05504Slice.reducer;
